import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Segmented tab control for admin toolbars — a pill group on a gray track where
 * the active segment lifts to white. Shared so every admin filter (assignment
 * weeks, programme lifecycle, …) looks and behaves the same.
 */
export function SegmentedTabs({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("inline-flex items-center gap-1 rounded-lg bg-gray-100 p-1", className)}>
      {children}
    </div>
  );
}

export function SegTab({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
        active ? "bg-white text-gray-900 shadow-sm" : "text-gray-600 hover:text-gray-900"
      )}
    >
      {children}
    </button>
  );
}
